import { NoticeDoNot } from '@fs/zion-icon'
import { useOverlay, IconButton } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import RestrictSelectedArtifactsOverlay from '../overlay/RestrictSelectedArtifactsOverlay'

export default function RestrictSelectedActionButton({ checkedArtifacts, setCheckedArtifacts, refetch, patron }) {
  const { t } = useTranslation()
  const restrictSelectedArtifactsOverlay = useOverlay()

  return (
    <>
      <IconButton
        title={t('action.restrictSelected', 'Restrict Selected')}
        onClick={restrictSelectedArtifactsOverlay.handleClick}
        Icon={NoticeDoNot}
        color="yellow"
        emphasis="high"
      />
      <RestrictSelectedArtifactsOverlay
        checkedArtifacts={checkedArtifacts}
        setCheckedArtifacts={setCheckedArtifacts}
        onSuccess={() => refetch()}
        patronId={patron?.id}
        {...restrictSelectedArtifactsOverlay}
      />
    </>
  )
}
